<template>
  <AhButton
    :id="id"
    :aria-expanded="displayMenu ? 'true' : 'false'"
    :aria-controls="ariaControls"
    type="button"
    :tracking="tracking"
    class="ah-burger-menu"
    :style="{
      width: burgerMenuWidth + 'rem',
      height: burgerMenuHeight + 'rem',
    }"
    @ah-button-clicked="handleClickBurgerMenu"
  >
    <span
      class="ah-burger-menu__icon"
      :class="`ah-burger-menu__icon--${displayMenu ? 'close' : 'open'}`"
    />
    <span class="ah-burger-menu__letters">{{ text }}</span>
  </AhButton>
</template>
<script>
  import AhButton from '../../atoms/AhButton/AhButton.vue';
  import { BURGER_MENU_LABELS } from '../../../constants/wording';

  export default {
    name: 'AhBurgerMenu',
    components: { AhButton },
    inject: {
      $lang: {
        default: () => function() { return 'en'; },
      }
    },
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      id: {
        type: String,
        default: 'ah-burger-menu',
      },
      ariaControls: {
        type: String,
        default: undefined,
      },
      tracking: {
        type: String,
        default: '',
      },
      burgerMenuWidth: {
        type: Number,
        default: 3,
      },
      burgerMenuHeight: {
        type: Number,
        default: 2.6,
      },
    },
    data() {
      return {
        isProcessing: false,
        displayMenu: this.isOpen,
      };
    },
    computed: {
      text() {
        return BURGER_MENU_LABELS[this.lang] || BURGER_MENU_LABELS['en'];
      },
      lang() {
        return this.$lang();
      }
    },
    watch: {
      isOpen: {
        handler(newValue) {
          if (this.isProcessing) {
            return;
          }
          newValue ? this.open() : this.close();
        },
      },
    },
    methods: {
      handleClickBurgerMenu() {
        if(this.isOpen) {
          this.close();
        } else {
          this.open();
        }
      },
      open() {
        this.displayMenu = true;
        this.isProcessing = true;
        this.$emit('burgerMenu:open', {
          id: this.id,
          tracking: this.tracking + ' Menu open',
        });
        setTimeout(() => (this.isProcessing = false), 400);
        window.scrollTo(0, 0);
      },
      close() {
        this.isProcessing = true;
        this.$emit('burgerMenu:close', {
          id: this.id,
          tracking: this.tracking + ' Menu close',
        });
        setTimeout(() => {
          this.displayMenu = false;
          this.isProcessing = false;
        }, 400);
      },
    },
  };
</script>
